module.exports = "/assets/data/4b5415ccc0b89b1e9a8659173b69ca2e-CA12.data.json";